import axios from 'axios';
import { API_ROOT, COLLECTIONS } from '../../urls';


export const fetchCategoryList = () => {
  const url = `${API_ROOT}/get_category_list`;
  return new Promise((resolve) => {
    // axios.get(url).then((res) => {
    //   const patientData = res.data
    //   resolve(patientData)
    // });
    const list = [{id: '12345', name: 'Blood Pressure', description: 'Blood Pressure', valueList: [], subCategoryList: [], noCategories: [], yesCategories: [], elementNumber: null, elementArray: []}, {id: '12346', name: 'Pulse', description: '', valueList: [], subCategoryList: [], noCategories: [], yesCategories: [], elementNumber: null, elementArray: []}]
    resolve(list)
  });
}

export const removeCategory = (category) => {
  const url = `${API_ROOT}/delete_category`;
  return new Promise((resolve) => {
    // axios.get(url).then((res) => {
    //   const patientData = res.data
    //   resolve(patientData)
    // });
    const list = [{id: '12345', name: 'Blood Pressure', description: 'Blood Pressure', valueList: [], subCategoryList: [], noCategories: [], yesCategories: [], elementNumber: null, elementArray: []}, {id: '12346', name: 'Pulse', description: '', valueList: [], subCategoryList: [], noCategories: [], yesCategories: [], elementNumber: null, elementArray: []}]
    resolve(list)
  });
}
export const updateCategory = (category) => {
  const url = `${API_ROOT}/post_subCategory`;
  return new Promise((resolve) => {
    // axios.get(url).then((res) => {
    //   const patientData = res.data
    //   resolve(patientData)
    // });
    const list = [{id: '12345', name: 'Blood Pressure', description: 'Blood Pressure', valueList: [], subCategoryList: [], noCategories: [], yesCategories: [], elementNumber: null, elementArray: []}, {id: '12346', name: 'Pulse', description: '', valueList: [], subCategoryList: [], noCategories: [], yesCategories: [], elementNumber: null, elementArray: []}]
    resolve(list)
  });
}

export const fetchUomList = () => {
  const url = `${API_ROOT}/get_uom_list`;
  return new Promise((resolve) => {
    // axios.get(url).then((res) => {
    //   const patientData = res.data
    //   resolve(patientData)
    // });
    const list = [{id: '12345', name: 'mmHg', description: 'millimeters of Mercury'}, {id: '12346', name: 'bpm', description: 'Beats per minute'}]
    resolve(list)
  });
}

export const removeUom = () => {
  const url = `${API_ROOT}/delete_uom`;
  return new Promise((resolve) => {
    // axios.get(url).then((res) => {
    //   const patientData = res.data
    //   resolve(patientData)
    // });
    const list = [{id: '12345', name: 'mmHg', description: 'millimeters of Mercury'}, {id: '12346', name: 'bpm', description: 'Beats per minute'}]
    resolve(list)
  });
}

export const updateUom = (uom) => {
  const url = `${API_ROOT}/post_uom`;
  return new Promise((resolve) => {
    // axios.get(url).then((res) => {
    //   const patientData = res.data
    //   resolve(patientData)
    // });
    const list = [{id: '12345', name: 'mmHg', description: 'millimeters of Mercury'}, {id: '12346', name: 'bpm', description: 'Beats per minute'}]
    resolve(list)
  });
}

export const fetchCategoryGroupsList = () => {
  const url = `${API_ROOT}/get_category_groups_list`;
  return new Promise((resolve) => {
    // axios.get(url).then((res) => {
    //   const patientData = res.data
    //   resolve(patientData)
    // });
    const list = [{id: '12345', name: 'groups1', description: 'groups1 Description', categoryList: ''}, {id: '12346', name: 'groups2', description: 'groups2 Description', categoryList: ''}]
    resolve(list)
  });
}

export const removeCategoryGroups = () => {
  const url = `${API_ROOT}/delete_category_groups`;
  return new Promise((resolve) => {
    // axios.get(url).then((res) => {
    //   const patientData = res.data
    //   resolve(patientData)
    // });
    const list = [{id: '12345', name: 'groups1', description: 'groups1 Description', categoryList: ''}, {id: '12346', name: 'groups2', description: 'groups2 Description', categoryList: ''}]
    resolve(list)
  });
}

export const updateCategoryGroups = (categoryGroups) => {
  const url = `${API_ROOT}/post_category_groups`;
  return new Promise((resolve) => {
    // axios.get(url).then((res) => {
    //   const patientData = res.data
    //   resolve(patientData)
    // });
    const list = [{id: '12345', name: 'groups1', description: 'groups1 Description', categoryList: ''}, {id: '12346', name: 'groups2', description: 'groups2 Description', categoryList: ''}]
    resolve(list)
  });
}

export const fetchTemplatesList = () => {
  const url = `${API_ROOT}/get_templates_list`;
  return new Promise((resolve) => {
    // axios.get(url).then((res) => {
    //   const patientData = res.data
    //   resolve(patientData)
    // });
    const list = [{id: '12345', name: 'Template One', description: 'Template One', categoryList: '', categoryGroupList: []}, {id: '12346', name: 'Template Two', description: 'Template Two', categoryList: '', categoryGroupList: []}]
    resolve(list)
  });
}

export const removeTemplate = () => {
  const url = `${API_ROOT}/delete_template`;
  return new Promise((resolve) => {
    // axios.get(url).then((res) => {
    //   const patientData = res.data
    //   resolve(patientData)
    // });
    const list = [{id: '12345', name: 'Template One', description: 'Template One', categoryList: '', categoryGroupList: []}, {id: '12346', name: 'Template Two', description: 'Template Two', categoryList: '', categoryGroupList: []}]
    resolve(list)
  });
}

export const updateTemplate = (categoryGroups) => {
  const url = `${API_ROOT}/post_template`;
  return new Promise((resolve) => {
    // axios.get(url).then((res) => {
    //   const patientData = res.data
    //   resolve(patientData)
    // });
    const list = [{id: '12345', name: 'Template One', description: 'Template One', categoryList: '', categoryGroupList: []}, {id: '12346', name: 'Template Two', description: 'Template Two', categoryList: '', categoryGroupList: []}]
    resolve(list)
  });
}
